import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase/config';
import { useNavigate } from 'react-router-dom';
import { setDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase/config';

const Register: React.FC = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
  });

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    const newErrors = {
      firstName: firstName ? '' : 'First name is required',
      lastName: lastName ? '' : 'Last name is required',
      email: email ? '' : 'Email is required',
      password:
        password.length >= 8 ? '' : 'Password must be at least 8 characters',
    };

    setErrors(newErrors);

    // if any errors exist, stop submission
    if (Object.values(newErrors).some(msg => msg !== '')) return;

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      await setDoc(doc(db, 'users', user.uid), {
        email: user.email,
        role: 'coach',
        firstName,
        lastName,
        teamId: 'team001',
      });

      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className='p-4 max-w-md mx-auto'>
      <h2 className='text-xl mb-4'>Register</h2>
      <form onSubmit={handleRegister} className='space-y-4'>
        <input
          type='text'
          placeholder='First name'
          className='w-full p-2 border'
          value={firstName}
          onChange={e => setFirstName(e.target.value)}
        />
        {errors.firstName && (
          <p className='text-red-500 text-sm'>{errors.firstName}</p>
        )}

        <input
          type='text'
          placeholder='Last name'
          className='w-full p-2 border'
          value={lastName}
          onChange={e => setLastName(e.target.value)}
        />
        {errors.lastName && (
          <p className='text-red-500 text-sm'>{errors.lastName}</p>
        )}

        <input
          type='email'
          placeholder='Email'
          className='w-full p-2 border'
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        {errors.email && <p className='text-red-500 text-sm'>{errors.email}</p>}

        <input
          type='password'
          placeholder='Password'
          className='w-full p-2 border'
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        {errors.password && (
          <p className='text-red-500 text-sm'>{errors.password}</p>
        )}

        {error && <p className='text-red-500'>{error}</p>}
        <button type='submit' className='bg-green-600 text-white px-4 py-2'>
          Create Account
        </button>
      </form>
    </div>
  );
};

export default Register;
